import React from 'react'
import { Link } from 'react-router-dom'
import BackgroundImage from '../../wp-adons/BackgroundImage'
export default function LodgingGalleryMap ({ jsonResponse }) {
  return (
    <>
      {/* <PreviousButton /> */}
      {jsonResponse &&
        jsonResponse.map((post, index) => (
          <div
            className='gallery w-full lg:w-[21.25rem] flex flex-col relative overflow-hidden justify-center items-center'
            key={index}
          >
            <div className='gallery  flex flex-col relative overflow-hidden justify-center items-center '>
              {post?.acf?.sub_title && (
                <p className='text-header5 relative z-10 text-center font-text_accent '>
                  {post.acf.sub_title}
                </p>
              )}
              {post?.acf?.image_title && (
                <p className='text-header1 relative z-10 text-center font-text_highlight '>
                  {post.acf.image_title}
                </p>
              )}
            </div>
            {post?.acf?.background_image?.image && (
              <div className='gallery w-full flex flex-col h-[44.375rem] relative overflow-hidden justify-center items-center gap-4'>
                {post?.acf?.background_image && (
                  <BackgroundImage
                    background_image={post.acf?.background_image}
                  />
                )}
                {post?.title?.rendered && (
                  <p className='text-header2 relative text-white z-10 text-center font-text_highlight '>
                    {post.title.rendered}
                  </p>
                )}
                <p
                  className='text-header4 relative z-10 text-white text-center font-text_readable overflow-hidden max-h-14'
                  dangerouslySetInnerHTML={{ __html: post?.acf?.description }}
                />
                {post?.acf?.cta && (
                  <Link
                    to={post?.acf?.cta}
                    className='text-header5 relative z-10 text-white border-solid border-white border-2 text-center font-text_readable mb-4 rounded-full p-2 px-5'
                  >
                    Discover More
                  </Link>
                )}
              </div>
            )}
          </div>
        ))}
      {/* <NextButton /> */}
    </>
  )
}
